import React, { useEffect, useRef } from 'react';

/**
 * HOC to subscribe for tab event.
 */
export function subscribe(Component, eventName = 'onNotify', callback = 'handleTabNotification') {
  const WrappedComponent = props => {
    const instanceRef = useRef(null);

    useEffect(() => {
      const storageChanged = event => {
        const func = instanceRef.current && instanceRef.current[callback];

        if (
          func &&
          ((typeof eventName === 'string' && event.key === eventName) ||
            (eventName instanceof Array && eventName.indexOf(event.key) > -1)) &&
          event.newValue
        ) {
          func(JSON.parse(event.newValue), event.key);
        }
      };

      window.addEventListener('storage', storageChanged);

      return () => {
        window.removeEventListener('storage', storageChanged);
      };
    }, []);

    return <Component {...props} ref={instanceRef} />;
  };

  WrappedComponent.displayName = `WrappedComponent(${Component.displayName || Component.name || 'WrappedComponent'})`;

  return WrappedComponent;
}

/**
 * HOC to add tab notifying function to component.
 */
export function publish(Component) {
  /**
   * Notify event to all opening tabs.
   *
   * @param {string} eventName Name of event.
   * @param {JSON} data Data to convey.
   */
  const notifyTab = (data = {}, eventName = 'onNotify') => {
    localStorage.setItem(eventName, JSON.stringify(data));
    localStorage.removeItem(eventName);
  };

  const Wrapper = props => <Component {...props} notifyTab={notifyTab} />;

  return Wrapper;
}
